export const CONNECTION_LOST = 'Connection Lost';
export const MESSAGE =
  'Looks like there’s a problem with your internet connection';
export const NO_INTERNET_CONNECTION = 'No internet connection';
export const BACK_ONLINE = 'You are back online';
